import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../../ReactKaamvalaWebsite/component/Home/Home";
// import Navbar from "../../ReactKaamvalaWebsite/component/Navbar/Navbar";
import Footer from "../../ReactKaamvalaWebsite/component/Footer/Footer";
import Hiring from "../../ReactKaamvalaWebsite/Pages/Hiring/Hiring";
import PricePlans from "../../ReactKaamvalaWebsite/Pages/PricePlans/PricePlans";
import RefundPolicy from "../../ReactKaamvalaWebsite/Pages/RefundPolicy/RefundPolicy";
import Culture from "../../ReactKaamvalaWebsite/Pages/Culture/Culture";
import About from "../../ReactKaamvalaWebsite/Pages/About/About";
import Contact from "../../ReactKaamvalaWebsite/Pages/contact/Contact";
import FQA from "../../ReactKaamvalaWebsite/Pages/FQA/FQA";
import Blog from "../../ReactKaamvalaWebsite/Pages/Blogs/Blog";
import NotFound from "../../ReactKaamvalaWebsite/Pages/Not-Found/NotFound";
import PrivacyPolicy from "../../User/Pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../../User/Pages/TermCondition/TermCondition";
import RefundCancellation from "../../User/Refund/RefundCancellation";
import Navbar from "../../../src/User/component/NavBar/Navbar";
const PublicRotes = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/post-job" element={<Hiring />} />
        <Route path="/price-detail" element={<PricePlans />} />
        <Route path="/policy" element={<RefundPolicy />} />
        <Route path="/culture" element={<Culture />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/fqa" element={<FQA />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-condition" element={<TermsAndConditions />} />
        <Route path="/refund-cancellation" element={<RefundCancellation />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
};
export default PublicRotes;
